'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var style = require('./style-d0a65e48.js');

var PasswordField = function (_a) {
    var value = _a.value, label = _a.label, placeholder = _a.placeholder, hideShowButton = _a.hideShowButton, errorText = _a.errorText, passwordHideText = _a.passwordHideText, passwordShowText = _a.passwordShowText, onChange = _a.onChange, onKeyDown = _a.onKeyDown;
    var _b = tslib_es6.__read(React.useState(false), 2), isPasswordShown = _b[0], setPasswordShown = _b[1];
    function onPasswordClick() {
        setPasswordShown(!isPasswordShown);
    }
    return (React__default.createElement(React__default.Fragment, null,
        label && React__default.createElement(style.Label, null, label),
        React__default.createElement(style.PasswordInfo, null,
            React__default.createElement(style.InputContainer, null,
                React__default.createElement(style.StyledPasswordInput, { onChange: onChange, onKeyDown: onKeyDown, placeholder: placeholder, type: isPasswordShown ? 'text' : 'password', value: value, errorText: errorText })),
            !hideShowButton && (React__default.createElement(style.StyledLink, { onClick: onPasswordClick, "data-testid": "password-link" }, isPasswordShown ? passwordHideText : passwordShowText)))));
};

exports.PasswordField = PasswordField;
